import React, { useEffect, useMemo, useRef, useState } from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { baseParametersTC } from "../../utils/tableau/TableauEmbed";
import { GeneralSelector } from "@bge/global_solution_workbench_commons";

const DashboardBattleCards = (
    {
        link, 
        locale,
        baseCompanies1,
        baseCompanies2,
        companySelected1,
        companySelected2,
        widthDashboard = 1000,
        heightDashboard = 800,
        baseCustomParameters,
        sidebar,
        setHideBar
    }) => {


    const customParameters = useMemo(() => {
        return baseCustomParameters ?? [...baseParametersTC, { name: ":language", value: locale }];
    }, [baseCustomParameters, locale]);
        
    const companies1 = useMemo(() => JSON.parse(baseCompanies1), [baseCompanies1]);
    const companies2 = useMemo(() => JSON.parse(baseCompanies2), [baseCompanies2]);

    const dashboardLoaded = useRef(false);
    const [currentCompany1, setCurrentCompany1] = useState(companies1[companySelected1]);
    const [currentCompany2, setCurrentCompany2] = useState(companies2[companySelected2]);
    
    useEffect(() => {
        dashboardLoaded.current = false;
    },[link])

    useEffect(() => {
        if(window.innerWidth > 767){
            if(sidebar === "HIDDEN"){
                setHideBar(sidebar);
            }else if(sidebar === "ALWAYS OPEN"){
                setHideBar(sidebar);
            }else if(sidebar === "CLOSED"){
                setHideBar(true);
            }else{
                setHideBar(null);
            }
        }
    },[sidebar, setHideBar])

    useEffect(() => {
        dashboardLoaded.current = false;
        setCurrentCompany1(companies1[companySelected1]);
        setCurrentCompany2(companies2[companySelected2]);
    },[companies1, companies2, companySelected1, companySelected2])


    useEffect(() => {
        if(!dashboardLoaded.current){
            fetch('https://svi43pyq2a26gzdihakztev72m0isxob.lambda-url.eu-west-1.on.aws/?app=gsw', {
                method: 'GET'
            }).then(response => {
                return response.text();
            }).then(token => {
                let viz = document.getElementById('viz');
                viz.innerHTML = "";
                let tableauViz = document.getElementById('tableauViz');

                tableauViz = document.createElement('tableau-viz');
                tableauViz.setAttribute('id', 'tableauViz');
                tableauViz.setAttribute('toolbar', 'hidden');
                tableauViz.setAttribute('hide-tabs', '');
                tableauViz.setAttribute('hide-edit-button', '');
                tableauViz.setAttribute('allow', 'fullscreen; autoplay');
                tableauViz.setAttribute('hide-edit-in-desktop-button', '');
                tableauViz.setAttribute('token', token);


                [...customParameters, {name: "pCompany1", value: currentCompany1.code}, {name: "pCompany2", value: currentCompany2.code}].forEach(param => {
                    let customParam = document.createElement('custom-parameter');
                    customParam.setAttribute('name', param.name);
                    customParam.setAttribute('value', param.value);
                    tableauViz.appendChild(customParam);
                });

                tableauViz.src = link;
                tableauViz.language = locale;

                viz.appendChild(tableauViz);

                dashboardLoaded.current = true;
            }).catch(error => {
                console.error(error);
            });
        }
    },[currentCompany1.code, currentCompany2.code, currentCompany1.name, currentCompany2.name, companies1, companies2, customParameters, link, locale]);

    return (
        <Row className="justify-content-md-center pt-4">
            <Col xs={12} className="mb-4 d-none d-sm-block battle-card_container">
                <div className="battle-card_selector_container" style={{width: `${widthDashboard}px`}}>
                    <GeneralSelector
                        current={currentCompany1.name}
                        passedItems={companies1}
                        clickHandler={(item)=> {dashboardLoaded.current = false; setCurrentCompany1(item)}}
                        requestHandler={null}
                        title="Baseline company"
                        classSelected={`company-selector ${companies1.length > 1 ? "list" : ""}`}
                        disabled={companies1.length === 1}
                    />
                    <GeneralSelector
                        current={currentCompany2.name}
                        passedItems={companies2}
                        clickHandler={(item)=> {dashboardLoaded.current = false; setCurrentCompany2(item)}}
                        requestHandler={null}
                        title="Company to compare"
                        classSelected="company-selector list"
                    />
                </div>
                <div className="m-auto" style={{height: `${heightDashboard}px`, width: `${widthDashboard}px`}}>
                    <div className="tableauBattleCard" id='viz'></div>
                </div>
                <div className="footer-gradient"></div>
            </Col>
        </Row>
    )
}

export default DashboardBattleCards;